export const FETCH_CHANNELS_REQUEST = 'FETCH_CHANNELS_REQUEST'
export const FETCH_CHANNELS_SUCCESS = 'FETCH_CHANNELS_SUCCESS'
export const FETCH_CHANNELS_FAILURE = 'FETCH_CHANNELS_FAILURE'

export const UPDATE_SELECTED_CHANNEL = 'UPDATE_SELECTED_CHANNEL'

export const CREATE_CHANNEL_REQUEST = 'CREATE_CHANNEL_REQUEST'
export const CREATE_CHANNEL_SUCCESS = 'CREATE_CHANNEL_SUCCESS'
export const CREATE_CHANNEL_FAILURE = 'CREATE_CHANNEL_FAILURE'

export const DELETE_CHANNEL_REQUEST = 'DELETE_CHANNEL_REQUEST'
export const DELETE_CHANNEL_SUCCESS = 'DELETE_CHANNEL_SUCCESS'
export const DELETE_CHANNEL_FAILURE = 'DELETE_CHANNEL_FAILURE'
